import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import './NADWaiverSectionSkeleton.styles.scss';

/**
 * Skeletal loader for the NAD Waiver section.
 * Matches the structure of NADWaiverTable (title + table with 5 columns).
 */
const NADWaiverSectionSkeleton: React.FC = () => {
  return (
    <section className="narrative-box nad-waiver-box nad-waiver-section-skeleton">
      <h4 className="narrative-box-text-title">
        <Skeleton width="10rem" height="1.25rem" />
      </h4>

      <div className="waiver-table-container">
        <div className="nad-waiver-table-skeleton">
          {/* Table header */}
          <div className="nad-waiver-table-header">
            {['Manufacturers', 'NAD Count', 'Issue Date', 'Expiry Date', 'Actions'].map(
              (_, i) => (
                <Skeleton key={i} width="100%" height="2rem" borderRadius="4px" />
              )
            )}
          </div>
          {/* Table rows */}
          {Array.from({ length: 4 }).map((_, rowIndex) => (
            <div key={rowIndex} className="nad-waiver-table-row">
              <Skeleton width="100%" height="1.75rem" borderRadius="4px" />
              <Skeleton width="3rem" height="1.5rem" borderRadius="4px" />
              <Skeleton width="90%" height="1.5rem" borderRadius="4px" />
              <Skeleton width="85%" height="1.5rem" borderRadius="4px" />
              <Skeleton width="5rem" height="2rem" borderRadius="4px" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NADWaiverSectionSkeleton;
